(function () {
  const logoUrl = "https://holamexico.de/cdn/shop/files/hola_mexico.png?v=1711487158&width=375";
  const links = [
    { text: "Über uns", href: "/pages/uber-uns" },
    { text: "Ladenlokal in Kerpen", href: "/pages/ladenlokal-in-kerpen" },
    { text: "Großhandel & B2B", href: "/pages/grosshandel-b2b" },
    { text: "B2B Portal", href: "/pages/b2b-registrierung" },
    { text: "Zahlung & Versand", href: "/pages/zahlung-versand" },
    { text: "Kontakt", href: "/pages/contact" },
    { text: "Impressum", href: "/policies/legal-notice" },
    { text: "Datenschutzerklärung", href: "/policies/privacy-policy" },
    { text: "Widerrufsrecht", href: "/policies/refund-policy" },
    { text: "AGB", href: "/policies/terms-of-service" }
  ];

  function buildMinimalFooter() {
    const footer = document.querySelector('.footer');
    if (!footer || footer.classList.contains('jdk-minimal-footer-applied')) return;
    footer.classList.add('jdk-minimal-footer-applied');

    // Remove everything except copyright/payment
    Array.from(footer.children).forEach(child => {
      if (
        !child.className.includes('footer__content-bottom') &&
        !child.className.includes('footer__content-bottom-wrapper')
      ) {
        child.remove();
      }
    });

    // Remove social icons, headlines, unnecessary links
    Array.from(footer.querySelectorAll('.list-social, .footer__list-social, .footer-block__heading, h2, h3')).forEach(e => e.remove());
    Array.from(footer.querySelectorAll('a')).forEach(a => {
      const txt = a.textContent.trim().toLowerCase();
      if (
        txt === "links" ||
        txt === "hola mexico club" ||
        txt === "muster-widerrufsformular"
      ) a.remove();
    });

    // Remove empty columns
    Array.from(footer.querySelectorAll('.footer-block')).forEach(col => {
      if (!col.textContent.trim()) col.remove();
    });

    // --- Minimal footer content
    const wrapper = document.createElement('div');
    wrapper.className = 'jdk-minimal-footer-row';

    const logoDiv = document.createElement('div');
    logoDiv.className = 'jdk-minimal-footer-logo';
    logoDiv.innerHTML = `<img src="${logoUrl}" alt="Hola Mexico" width="180" height="32" class="jdk-minimal-footer-logo-img" loading="lazy" decoding="async" />`;

    const linksDiv = document.createElement('nav');
    linksDiv.className = 'jdk-minimal-footer-links';
    links.forEach(link => {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.text;
      a.className = 'jdk-minimal-footer-link';
      linksDiv.appendChild(a);
    });

    wrapper.appendChild(logoDiv);
    wrapper.appendChild(linksDiv);

    // Insert at the top of the footer
    footer.prepend(wrapper);

    // --- Inject CSS if not already present
    if (!document.getElementById('jdk-minimal-footer-style')) {
      const style = document.createElement('style');
      style.id = 'jdk-minimal-footer-style';
      style.textContent = `
.jdk-minimal-footer-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 32px;
  padding: 24px 0 0 0;
  max-width: 1440px;
  margin: 0 auto;
  flex-wrap: wrap;
  /* border-top removed */
}
.jdk-minimal-footer-logo {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}
.jdk-minimal-footer-logo-img {
  height: 32px;
  width: auto;
  max-width: 180px;
  filter: brightness(0) invert(1) grayscale(1) contrast(10000%);
  background: transparent;
}
.jdk-minimal-footer-links {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7px;
  font-family: var(--font-body-family, Assistant, sans-serif);
  font-size: 1.3rem;
  line-height: 1.7;
  margin-left: auto;
}
.jdk-minimal-footer-link {
  color: rgba(var(--color-foreground, 18,18,18), 0.75);
  text-decoration: none;
  transition: color 0.15s;
  font-weight: 400;
  padding: 1px 0;
}
.jdk-minimal-footer-link:hover,
.jdk-minimal-footer-link:focus {
  color: #743A84;
  text-decoration: underline;
}
@media (max-width: 750px) {
  .jdk-minimal-footer-row {
    flex-direction: column;
    align-items: center;
    gap: 18px;
    padding: 18px 0 0 0;
  }
  .jdk-minimal-footer-logo {
    justify-content: center;
    width: 100%;
    margin-bottom: 7px;
  }
  .jdk-minimal-footer-links {
    align-items: center;
    margin-left: 0;
    font-size: 1.2rem;
  }
}
      `;
      document.head.appendChild(style);
    }
  }

  // --- Run immediately if possible
  buildMinimalFooter();

  // --- Mutation observer for AJAX navigation (Shopify, SPA)
  const observer = new MutationObserver(() => {
    buildMinimalFooter();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Cleanup observer after first successful run
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => {
      const footer = document.querySelector('.footer');
      if (footer && footer.classList.contains('jdk-minimal-footer-applied')) {
        observer.disconnect();
      }
    }, 1500);
  });
})();
